import React from "react";
import PropTypes from "prop-types";
import PlainButton from "./plain-button";
import Icon from "./icon";

const IconButton = React.forwardRef(({ className, icon, innerClassName, size, title, children, ...props }, ref) => {
  return (
    <PlainButton className={className} ref={ref} {...props} aria-label={title}>
      <Icon icon={icon} size={size} className={innerClassName} aria-hidden="true" />
      {children}
    </PlainButton>
  );
});

IconButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  innerClassName: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export default IconButton;
